import { createComponent as _$createComponent } from "solid-js/web";
/**
 * Layer Renderer - Mounts/unmounts layer components based on enabled state
 */

import { For, Show } from "solid-js";
import { Dynamic } from "solid-js/web";
import { layers } from "../stores/layers";
import { getAllLayers } from "./registry";
export function LayerRenderer() {
  const registeredLayers = getAllLayers();
  return _$createComponent(For, {
    each: registeredLayers,
    children: layer => _$createComponent(Show, {
      get when() {
        return layers[layer.id];
      },
      get children() {
        return _$createComponent(Dynamic, {
          get component() {
            return layer.component;
          }
        });
      }
    })
  });
}